/*eslint-disable*/
import api from '../'

class transferSyllablesGameItems {
    // POST: couples
    static getItemsByRequest (params) {
        return api.axios.get('/transferSyllables/items', { params }).then(response => response.data.items);
    }
}

export default transferSyllablesGameItems;
